/* Custom JS for Sample Order Page */

document.addEventListener('DOMContentLoaded', () => {
  const config = window.sampleOrderConfig;
  const items = document.querySelectorAll('.sample-item');
  const noteEl = document.getElementById('current-samples-count');
  const addBtn = document.getElementById('add-samples-to-cart');
  const selectedSamples = new Set();

  // Filter JS logic
  const filterBtns = document.querySelectorAll('.sample-filter-btn');
  const sampleItems = document.querySelectorAll('.sample-item');

  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      // Active State
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const filterValue = btn.getAttribute('data-filter');

      sampleItems.forEach(item => {
        const itemColor = item.getAttribute('data-color');
        if (filterValue === 'all' || itemColor === filterValue) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    });
  });

  // Init state
  updateUI();

  // Event Listeners for Items
  items.forEach(item => {
    const btn = item.querySelector('.sample-btn-add');
    const productId = item.dataset.productId;
    const title = item.dataset.productTitle;
    const variantId = item.dataset.sampleVariantId;
    const previewSrc = item.dataset.previewSrc; // New data attr
    const key = productId; // Using product ID as unique key for sample

    // 1. Preview Click Handler (Entire Row)
    item.addEventListener('click', (e) => {
      // If clicked on the add button, do nothing here (handled below)
      if (e.target.closest('.sample-btn-add')) return;

      if (previewSrc) {
        // Update Main Gallery Image
        // We target the currently active slide's image or the first one if unsure
        const gallery = document.querySelector('product-gallery');
        if (gallery) {
          // Try to find the visible image
          // Standard Shopify gallery has li.is-active
          let activeImg = gallery.querySelector('.product__media-item.is-active img');
          if (!activeImg) {
            // Fallback to first image
            activeImg = gallery.querySelector('.product__media-item img');
          }

          if (activeImg) {
            activeImg.src = previewSrc;
            activeImg.srcset = previewSrc; // Override srcset to prevent browser swapping back
          }
        }
      }
    });

    // 2. Selection/Add Handler (Button Only)
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation(); // Stop bubbling to preview handler if needed, though the check above handles it.

      if (selectedSamples.has(key)) {
        selectedSamples.delete(key);
        item.classList.remove('selected');
      } else {
        if (selectedSamples.size >= config.maxSamples) return; // Limit reached
        selectedSamples.add(key);
        item.classList.add('selected');
      }

      updateUI();
      updateButtonState(item);
    });
  });

  // Update Global UI
  function updateUI() {
    const count = selectedSamples.size;
    noteEl.textContent = `${count}/${config.maxSamples}`;

    // Toggle Button Disabled
    if (count > 0) {
      addBtn.removeAttribute('disabled');
    } else {
      addBtn.setAttribute('disabled', 'true');
    }

    // Disable unselected items if limit reached
    items.forEach(item => {
      const key = item.dataset.productId;
      if (!selectedSamples.has(key) && count >= config.maxSamples) {
        item.classList.add('disabled');
      } else {
        item.classList.remove('disabled');
      }
    });
  }

  // Update Item Button UI (+ vs check)
  function updateButtonState(item) {
    const isSelected = item.classList.contains('selected');
    const iconPlus = item.querySelector('.icon-plus');
    const iconCheck = item.querySelector('.icon-check');

    if (isSelected) {
      iconPlus.classList.add('hidden');
      iconCheck.classList.remove('hidden');
    } else {
      iconPlus.classList.remove('hidden');
      iconCheck.classList.add('hidden');
    }
  }

  // Add to Cart Handlers
  addBtn.addEventListener('click', async () => {
    if (selectedSamples.size === 0) return;

    addBtn.classList.add('loading');
    addBtn.textContent = 'Wird hinzugefügt...';

    const itemsToAdd = [];
    const errorItems = [];

    // Build Payload
    items.forEach(item => {
      if (item.classList.contains('selected')) {
        const sampleVariantId = item.dataset.sampleVariantId; // Option A
        const productTitle = item.dataset.productTitle; // fallback Label

        if (sampleVariantId && sampleVariantId !== '') {
          // Option A: Specific Variant
          itemsToAdd.push({
            id: parseInt(sampleVariantId),
            quantity: 1
          });
        } else {
          // Option B: Fallback Main Product Variant + Property
          if (config.mainProductVariantId && config.mainProductVariantId !== 'null') {
            itemsToAdd.push({
              id: parseInt(config.mainProductVariantId),
              quantity: 1,
              properties: {
                'Muster': productTitle
              }
            });
          } else {
            errorItems.push(productTitle);
          }
        }
      }
    });

    if (errorItems.length > 0) {
      console.error('Missing main product variant ID for fallback:', errorItems);
      // Often better to not block the ones that work, but here we likely have all or nothing logic if config is missing
      if (itemsToAdd.length === 0) {
        alert('Konfiguration fehlerhaft: Kein Muster-Produkt hinterlegt und keine individuellen Muster-IDs gefunden.');
        addBtn.classList.remove('loading');
        addBtn.textContent = 'In den Warenkorb';
        return;
      }
    }

    // Send to Shopify
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: itemsToAdd })
      });

      if (response.ok) {
        // Redirect to Cart or Open Drawer depending on theme. 
        // Standard behavior: redirect to cart or reload to update mini-cart
        window.location.href = window.Shopify.routes.root + 'cart';
      } else {
        const errJson = await response.json();
        console.error('Cart Error:', errJson);
        alert('Fehler beim Hinzufügen zum Warenkorb. Bitte versuchen Sie es erneut.');
      }

    } catch (error) {
      console.error('Fetch error:', error);
      alert('Ein unerwarteter Fehler ist aufgetreten.');
    } finally {
      addBtn.classList.remove('loading');
      addBtn.textContent = 'In den Warenkorb';
    }
  });
});
